import { Controller } from "@hotwired/stimulus"

export default class AlarmIconBadgeController extends Controller {
  static targets = ["badge"]

  connect() {
    this.requestData()
  }

  requestData() {
    fetch('/api/v1/alarms?count_only=true', { headers: { Accept: 'application/json' } })
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`)
        return r.json()
      })
      .then(data => {
        if (this.hasBadgeTarget) {
          const count = data?.count || null
          this.badgeTarget.textContent = count ?? ''
          this.badgeTarget.classList.toggle('d-none', count === null)
        }
      })
      .catch(err => console.warn('[AlarmIconBadge]', err))
  }
}
